<template>
  <div class="fileEditDropdown">
    <el-popover ref="popover" width="146" trigger="click" :append-to-body="false" placement="bottom-end"
      @show="listShow" @hide="listHide">
      <div class="operate">
        <div class="item" :class="[item.type == 'error' && 'error']" @click.stop="handlerClick(item.value)"
          v-for="(item, index) in getOptions" :key="index" v-show="hiddenList(item)">
          {{ item.lable }}
        </div>
      </div>
      <span slot="reference"><img class="more-icon" :src="getDarkIcon('more')" /></span>
    </el-popover>
    <!-- 重命名 -->
    <rename :visible.sync="visible" :rename="item.fileNameStr" @changeName='fileRename' />
  </div>
</template>
<script>
import { renameFile, delFiles } from '@/api/network/printer'
import { openModelDir, importModel, moveFile } from '@/api/slicer/printer'
import { px } from '@/utils/common';
import rename from '@/views/components/dialog/rename'
import { mapState } from 'vuex';
export default {
  name: "fileEditDropdown",
  components: { rename },
  props: {
    item: {
      type: Object,
      default: () => { }
    },
    type: {
      type: String,
      default: () => 'list'
    }
  },
  computed: {
    ...mapState({
      downloadFileList: (state) => state.user.downloadFileList,
    }),
    // 判断暗色图标
    getDarkIcon () {
      return (str) => {
        return this.$store.getters.GET_IS_DARK
          ? require(`@/assets/dark/${str}.webp`)
          : require(`@/assets/imgs/${str}.png`)
      }
    },
    getOptions () {
      return this.type == 'list'
        ? this.options.list
        : this.options.grid
    },
    hiddenList () {
      return obj => {
        let faild = false
        const type = this.item.file_extension?.toLowerCase()
        const arr = ['3mf', 'gcode', 'obj', 'step']
        switch (obj.value) {
          case 'Open folder':
            faild = this.item.fileStateStr == 'import' ? true : false
            break;
          case 'Details':
            faild = type == 'gcode' ? true : false
            break;
          default:
            faild = true
          // case 'SelectAll':
          //   faild = true;
          //   break;
          // case 'SelectAll':
          //   faild = true;
          //   break;
        }
        return faild
      }
    },
  },
  watch: {
    height: {
      handler (val) {
        const el = document.querySelectorAll('.el-table__body-wrapper')[0]
        if (val) {
          el.style.height = el.clientHeight + 100 + 'px'
          // el.scrollTop = el.clientHeight
        } else {
          el.style.height = ''
          // el.scrollTop = el.clientHeight
        }
      },
    }
  },
  data () {
    return {
      options: {
        list: [
          { lable: this.$t('view_details'), value: 'Details', type: 'defalt' },
          { lable: this.$t('open_folder'), value: 'Open folder', type: 'defalt' },
          { lable: this.$t('rename'), value: 'Rename', type: 'defalt' },
          { lable: this.$t('delete'), value: 'Delete', type: 'error' },
        ],
        grid: [
          { lable: this.$t('open_folder'), value: 'Open folder', type: 'defalt' },
          { lable: this.$t('rename'), value: 'Rename', type: 'defalt' },
          { lable: this.$t('delete'), value: 'Delete', type: 'error' },
        ]
      },
      visible: false,
      height: 0 //  存储高度，解决最后一条数据下拉列表显示不全
    }
  },
  methods: {
    //  二次判断云空间文件与本地文件是否一致
    async getUniqueFile (str) {
      const list = this.$store.state.printer.userDownloadList
      const userId = this.$store.state.user.uploadCenter_user_info.id
      const index = list.findIndex(item => item.id == userId)
      const md5 = await fileMd5(str)
      const faild = index != -1
        ? list[index][str] == md5
        : false

      return faild
    },
    listShow (ev) {
      const popover = this.$refs.popover
      const el = document.querySelectorAll('.fileList')[0]
      if (popover) {
        const rect = popover.$el.getBoundingClientRect()
        this.height = rect.bottom > 800 && el.scrollHeight == el.offsetHeight ? 80 : 0
      }
    },
    listHide () {
      if (!this.height) return
      this.height = 0
    },
    handlerClick (val) {
      switch (val) {
        case 'Details':
          this.$emit('openViewInfo', this.item)
          break;
        case 'Import':
          this.fileImport(this.item);
          break;
        case 'Open folder':
          this.fileOpenFolder();
          break;
        case 'Download':
          this.fileDownload();
          break;
        case 'Rename':
          this.openRename();
          break;
        case 'Delete':
          this.fileDelete();
          break;
      }
      this.$nextTick(() => {
        this.$refs.popover.doClose()
      })
    },
    //  fileDetails
    fileDetails () {

    },
    //  fileOpenFolder
    fileOpenFolder () {
      openModelDir('');
    },
    //  fileDownload
    fileDownload () {
      console.log('fileDownload');
    },
    openRename () {
      this.visible = true
    },
    //  fileRename
    async fileRename (val) {
      const oldName = this.item.old_filename
      const params = {
        id: this.item.id,
        name: val
      }
      const res = await renameFile(params)
      if (res.code != 1) return
      const fileNameStr = res.data.split('.').splice(0, res.data.split('.').length - 1).join('.')
      this.$emit('pushUserMd5', 'update', res.data, oldName, '')
      this.$emit('fileChange', 'update', Object.assign(this.item, { old_filename: res.data, fileNameStr }))

    },
    //  fileDelete
    async fileDelete () {
      this.$confirm(this.$t("confirm_delete"), this.$t("tips"), {
        confirmButtonText: this.$t("confirm"),
        cancelButtonText: this.$t("Cancel"),
        type: "warning",
        center: true,
        customClass: this.$store.getters.GET_IS_DARK ? 'dark-model' : ''
      })
        .then(() => {
          this.delModel()
        })
        .catch(() => {
          // this.$message.info("已取消删除!");
        });
    },
    async delModel () {
      const params = {
        idArr: [this.item.id]
      }
      const res = await delFiles(params)
      if (res.code == 1) {
        this.$emit('fileChange', 'del', this.item)
      }

      //  当前任务在下载，需要删除该下载数据
      const index = this.downloadFileList.findIndex(item => item.id == this.item.id)
      if (index !== -1) {
        this.$emit('cancelDownload', this.item.id)
      }
    }
  },
}
</script>
<style scoped lang="scss">
.fileEditDropdown {
  width: 32px;
  height: 32px;
  cursor: pointer;
}

::v-deep {
  .el-dropdown {
    width: 32px;
  }
}

.operate {
  // width: 146px;
  background-color: var(--dialog-background-color);
  // box-shadow: 1px 1px 0px 0px #2D2D31;
  border-radius: 0px 0px 0px 0px;

  // border: 1px solid #DBDBDB;
  .item {
    width: 100%;
    height: 28px;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid transparent;
    font-weight: normal;
    font-size: 13px;
    color: var(--first-text-color);
    line-height: 28px;
    padding: 0 10px;
    box-sizing: border-box;
    cursor: pointer;
    white-space: nowrap;
    /* 确保文本在一行内显示 */
    overflow: hidden;
    /* 隐藏溢出的内容 */
    text-overflow: ellipsis;

    /* 使用省略号表示文本溢出 */
    &:hover {
      // background: rgba(67, 141, 255, 0.24);
      border-radius: 0px 0px 0px 0px;
      border: 1px solid var(--VI-color);
    }
  }

  .error {
    color: #FF524D;
  }
}

.more-icon {
  width: 32px;
  height: 32px;
}

.more-icon:active {
  background-color: rgba(67, 141, 255, 0.16);
  border-radius: 6px 6px 6px 6px;
  border: 1px solid var(--VI-color);
}

::v-deep {
  .el-popover {
    padding: 0px;
    margin-top: 0px;
    border: 1px solid var(--input-border-color);

    .popper__arrow {
      display: none;
    }
  }
}
</style>